import React from "react";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";

/**
 * LegalPage — shared shell for policy/legal pages so structure and SEO stay consistent.
 * Content is prose HTML/JSX only. No claims of accuracy, government affiliation, or
 * guaranteed outcomes are ever made in any legal page.
 */
export default function LegalPage({ path, title, description, heading, updated, children }) {
  const bc = [{ name: "Home", path: "/" }, { name: heading, path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-14 sm:py-20">
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">{heading}</h1>
        {updated && <p className="mt-2 text-xs text-muted-foreground">Last updated: {updated}</p>}
        <div className="prose prose-slate dark:prose-invert mt-8 max-w-none">{children}</div>
      </section>
    </PublicPageLayout>
  );
}
